module.exports = __webpack_public_path__ + "static/3-7b24b0eeb5c18a04ee1baf3d8fbf0649.svg";